import classes from './UpdateExistingModelModal.module.scss'
import { Button } from 'primereact/button'
import ConfirmationModalV2 from '../../confirmation-modal-v2/ConfirmationModalV2'
import { DataTable } from 'primereact/datatable'
import { Column, ColumnBodyOptions } from 'primereact/column'

interface UpdateExistingModel {
  updatedModelName: string
  previousModelName: string
  productType: string
  ulAssetId: string
  selectedModel: any
  isBaseModel: boolean
}

interface UpdateExistingModelModalProps {
  visible: boolean
  onConfirm: () => void
  onCancel: () => void
  modelList: UpdateExistingModel[]
}

const UpdateExistingModelModal = (props: UpdateExistingModelModalProps) => {
  const modalHeader = 'Updated Model Detected'

  const colTemplate = (data: any, opt: ColumnBodyOptions) => (
    <div
      className={`${classes['col-text-div']}
        } ul-grid__column`}
    >
      {data[opt.field]}
    </div>
  )

  const table = (
    <DataTable
      value={props.modelList}
      className={classes['adjustments-table']}
      size="small"
      showGridlines={true}
    >
      <Column
        header="Updated Model Name"
        field="updatedModelName"
        body={colTemplate}
        className={`${classes['table-col']} ${classes['col-updatedModelName']}`}
      />
      <Column
        header="Previous Model Name"
        field="previousModelName"
        body={colTemplate}
        className={`${classes['table-col']} ${classes['col-previousModelName']}`}
      />
      <Column
        header="Product Type"
        field="productType"
        body={colTemplate}
        className={`${classes['table-col']} ${classes['col-productType']}`}
      />
    </DataTable>
  )

  const renderTableHeader = () => {
    return (
      <>
        <p className={`${classes['modal-body-text']}`}>
          This Model is already associated with the certificate under a previous version.
          Associating this updated Model will replace the existing version of the Model on the
          certificate.
        </p>

        <p className={`${classes['modal-body-text']}`}>Do you want to proceed?</p>
      </>
    )
  }

  const bodyTemplate = (
    <>
      {renderTableHeader()}
      {table}
    </>
  )

  const footerTemplate = (
    <>
      <Button label={'CANCEL'} onClick={props.onCancel} className={classes['btn-cancel']} />

      <Button
        label={'CONFIRM'}
        onClick={() => props.onConfirm()}
        className={classes['btn-confirm']}
      />
    </>
  )

  return (
    <ConfirmationModalV2
      bodyClassName={`${classes['modal-body']}`}
      style={{ width: '40vw' }}
      visible={props.visible}
      onClose={props.onCancel}
      headerDisplay={modalHeader}
      customFooter={footerTemplate}
      confirmationMessageHTML={bodyTemplate}
    ></ConfirmationModalV2>
  )
}

export default UpdateExistingModelModal
